module.exports = __webpack_public_path__ + "img/je.ebf8c8c5.svg";